<template>
    <v-layout column class="feature-event-list" mb-3>
        <v-card-title class="feature-event-list__title"></v-card-title>
        <div id="content">
            <grid-layout 
                :layout.sync="featureItem.eventList" 
                :col-num="1" 
                :row-height="85"
                :is-draggable="true" 
                :is-resizable="false" 
                :vertical-compact="true" 
                :auto-size="true"
                :margin="[2, 2]" 
                :use-css-transforms="true">
                <grid-item v-for="(event, idx) in featureItem.eventList" :key="idx"
                    :x.sync= "event.x"
                    :y.sync= "event.y"
                    :w.sync= "event.w"
                    :h.sync= "event.h"
                    :i= "event.i">
                    <v-flex xs12 
                            :key="`${idx}_${event.id}`"
                            :id="`${idx}_${event.id}`"
                            :data-qe-id="`feature-event_item_${idx}_${event.id}`"
                            class="feature-event-list__event">
                        <v-layout row align-content-space-between pt-2 pb-2>
                            <v-flex xs2 sm1 pt-4 pl-3>
                                <v-icon>drag_indicator</v-icon>
                            </v-flex>
                            <v-flex xs7 sm9 pt-3 class="text-left ypo_cta_blue_color bold-font">
                                <div v-if="getEventTitle(event)"
                                    class=""
                                    >
                                    <v-flex @click="activateEdit(event.id)"
                                            :data-qe-id="`feature-event_${idx}_edit_link`"
                                            class="pointer">
                                       <span class="feature-event-list__event-label"> {{getEventTitle(event)}}</span>
                                    </v-flex>
                                    
                                </div>
                                <v-img v-if="!getEventTitle(event) && event.featuredPostImage && event.featuredPostImage.url"
                                    height="40"
                                    width="40"
                                    class="pointer"
                                    :data-qe-id="`feature-event_${idx}_edit_link`"
                                    @click="activateEdit(event.id)"
                                    :src="event.featuredPostImage.url"></v-img>
                            </v-flex>
                            <v-flex xs3 sm2 pt-2 pr-3 class="text-right ypo_cta_blue_color">
                                <v-icon color="ypo_cta" class="pointer" large
                                        :data-qe-id="`feature-event_${idx}_delete_btn`"
                                        @click="openDeleteDialogBox(event)">
                                    delete
                                </v-icon>
                                <div class="pointer"
                                     :data-qe-id="`feature-event_${idx}_delete_confirm`"
                                     @click="openDeleteDialogBox(event)">
                                    {{appCommonConstants.DELETE}}
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </grid-item>
            </grid-layout>
        </div>
        <v-flex xs12 pa-3 class="feature-event-list__add-new">
            <v-btn flat
                class="feature-event-list__add-new-button"
                @click="changeComponent(communityCommonConstant.featureEvent.componentNames.createFeatureEvent)"
                data-qe-id="add_new_feature_item_btn"
                id="add_new_feature_item">
                {{communityCommonConstant.featureEvent.ADD_FEATURE_ITEM}}
            </v-btn>
        </v-flex>
        <status-bar :action="reorderAction"></status-bar>
        <v-card-actions class="feature-event-list__action">
            <v-layout row wrap pa-2>
                <v-flex xs5 text-left>
                    <v-btn flat color="ypo_cta"
                        @click="handleCancel(featureItem)"
                        data-qe-id="feature-event_back_btn"
                        class="bold-font">
                        <v-icon>keyboard_backspace</v-icon>
                        <span class="feature-event-list__action-back">{{appCommonConstants.BACK}}</span>
                    </v-btn>
                </v-flex>
                <v-flex text-right>
                <v-btn class="create-feature-event__cancel_btn"
                    flat
                    id="feature_item_cancel"
                    data-qe-id="feature-event_cancel_btn"
                    @click.native="cancel(featureItem)">
                    {{appCommonConstants.CANCEL}}
                </v-btn>
                <v-btn class="create-feature-event__save_btn"
                    color="primary"
                    id="feature_item_save"
                    data-qe-id="feature-event_save_btn"
                    @click.native="saveOrders()">
                    {{appCommonConstants.SAVE}}
                </v-btn>
            </v-flex>
            </v-layout>
            
            
        </v-card-actions>

        <v-dialog v-model="deleteDialog" v-if="featureEventToDelete" lazy absolute content-class="delete-dialog" max-width="600px">
            <v-card>
                <v-card-title>
                    <v-layout align-center justify-space-between>
                        <div class="headline">{{appCommonConstants.DELETE}}</div>
                        <v-btn icon id="cancel_cross_btn" class="delete-dialog__close-btn"
                               data-qe-id="close_dialog_btn"
                               @click="cancelDelete()">
                            <v-icon size="30">close</v-icon>
                        </v-btn>
                    </v-layout>
                </v-card-title>
                <status-bar :action="deleteAction"></status-bar>
                <v-card-text>
                        <div data-qe-id="feature-event_delete_message">
                            {{communityCommonConstant.featureEvent.DELETE_CONFIRMATION}}
                        </div>
                        <div class="delete-dialog__delete-item-title" data-qe-id="feature-event_delete_event-title">
                            {{getEventTitle(featureEventToDelete) ? `"${getEventTitle(featureEventToDelete)}"`: '' }}
                        </div>
                </v-card-text>
                <v-card-actions>
                    <v-layout justify-end>
                        <v-btn flat @click="cancelDelete()"
                               data-qe-id="feature-event_delete_cancel_btn"
                               class="bold-font br-4"
                               id="cancel_dialog_btn">
                            {{appCommonConstants.CANCEL}}
                        </v-btn>
                        <v-btn dark
                               @click="deleteSelectedEvent(featureEventToDelete.id)"
                               data-qe-id="feature-event_delete_confirm_btn"
                                color="primary"
                                id="confirm_delete_btn"
                                class="bold-font br-4">
                            {{appCommonConstants.DELETE}}
                        </v-btn>
                    </v-layout>
                </v-card-actions>
            </v-card>      
        </v-dialog>
    </v-layout>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex';
    import { communityCommonConstant } from "../communityCommon.constant";
    import { appCommonConstants } from "../../appCommon.constants";
    import { storeAction } from "../../../store/storeActions.constant";
    import StatusBar from "../../StatusBar/StatusBar";
    import { storeMutation } from "../../../store/storeMutations.constant";

    export default {
        name: 'FeatureEventList',
        components: { StatusBar },
        data() {
            return {
                communityCommonConstant,
                appCommonConstants,
                deleteDialog: false,
                featureEventToDelete: null,
            };
        },
        props: {
            featureItem: {
                type: Object,
                required: true,
            },
            changeComponent: {
                type: Function,
            },
        },
        methods: {
            ...mapActions({
                deleteEvent: `chapter/${storeAction.deleteFeatureEvent}`,
                saveReorderedFeatureEvent: `chapter/${storeAction.saveReorderedFeatureEvent}`,
            }),
            ...mapMutations({
                addFeatureItemToEdit: `chapter/${storeMutation.updateFeatureEventInEdit}`,
                updateFeatureItemInState: `chapter/${storeMutation.updateFeatureEvents}`,
            }),
            openDeleteDialogBox(featureEvent) {
                this.featureEventToDelete = {
                    ...featureEvent,
                };
                this.deleteDialog = true;
            },
            cancelDelete() {
                this.featureEventToDelete = null;
                this.deleteDialog = false;
            },
            deleteSelectedEvent(eventId) {
                this.deleteEvent(eventId)
                    .then(() => {
                        this.featureEventToDelete = null;
                        this.deleteDialog = false;
                    });
            },
            activateEdit(eventId) {
                this.addFeatureItemToEdit(eventId);
                this.changeComponent(communityCommonConstant.featureEvent.componentNames.createFeatureEvent);
            },
            handleCancel(item) {
                this.updateFeatureItemInState(item);
                this.changeComponent(communityCommonConstant.featureEvent.componentNames.manageFeatureEvent);
            },
            cancel(item) {
                this.updateFeatureItemInState(item);
            },
            saveOrders() {
                this.isSubmitting = true;
                this.featureItem.eventList.forEach((post) => {
                    post.order = post.y;
                });
                this.saveReorderedFeatureEvent(this.featureItem.eventList)
                    .then((response) => {
                        this.isSubmitting = false;
                        this.featureItem = response.data;
                    })
                    .catch(() => {
                        this.isSubmitting = false;
                    });
            },
            getEventTitle(event) {
                return event.title || event.subtitle || event.url || event.body || null;
            },
        },
        computed: {
            ...mapState("actionState", ["actions"]),
            deleteAction() {
                return this.actions[storeAction.deleteFeatureEvent];
            },
            reorderAction() {
                return this.actions[storeAction.reorderFeatureEvent];
            },
        },
    };
</script>

<style lang="scss" scoped>

    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_commonClasses.scss';
    @import '../../../common/styles/_responsive.scss';

    .feature-event-list {
        border: 1px solid $ypo-medium-gray;
        background-color: $ypo-cta;
        border-radius: 4px;
        padding: 1px;

        &__event {
            background-color: white;
            border-bottom: 1px solid $ypo-medium-gray;

            &-label {
                text-overflow: ellipsis;
                padding-top: 10px;
                display: inline-block;
                overflow: hidden;
                word-break: break-word;
                white-space: nowrap;
                padding-right: 10px;
                width: 100%;
            }
        }

        &__title {
            background-color: $ypo-cta;
        }

        &__add-new {
            background-color: $white;
            max-height: 80px;
            border-bottom: 1px solid $ypo-medium-gray;

            &-button {
                width: 100%;
                margin: 0;
                font-size: 16px;
                padding: 10px;
                font-weight: 600;
                color: $ypo-cta;
                border: 1px solid $ypo-cta;
                border-radius: 4px;
                height: auto;
            }
        }

        &__action {
            background-color: $white;
            padding: 15px 0;

            &-back {
                padding-left: 5px;
            }
        }
        @include breakpoint(xs) {
            &__event {
                touch-action: none;
        }
        }
        
    }

    .delete-dialog {

        .headline {
            color: $ypo-dark-gray;
            font-family: Raleway, serif !important;
            font-size: 24px;
            line-height: 29px;
            padding-left: 10px;
        }

        .v-card__text {
            padding-left: 30px;
            font-size: 16px;
            color: $ypo-gray;
        }

        .v-card__actions {
            padding: 40px 35px 10px 0 !important;

            .v-btn {
                min-width: 115px;
                letter-spacing: 1.25px;
            }
        }

        &__delete-item-title {
            margin-top: 10px;
            color: $ypo-cta !important;
        }
    }
</style>
<style lang="scss">
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    @include breakpoint(xs) {
    .vue-grid-item.cssTransforms {
            touch-action: none;
        }
    }
    
</style>
